import { render, staticRenderFns } from "./OrganizationMembersNew.vue?vue&type=template&id=4288cd87&scoped=true&lang=pug&"
import script from "./OrganizationMembersNew.vue?vue&type=script&lang=js&"
export * from "./OrganizationMembersNew.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationMembersNew.vue?vue&type=style&index=0&id=4288cd87&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288cd87",
  null
  
)

export default component.exports